/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminEbayEnvironment = {
    EbayEnvironmentSandbox: 'sandbox',
    EbayEnvironmentProduction: 'production'
} as const;
export type AdminEbayEnvironment = typeof AdminEbayEnvironment[keyof typeof AdminEbayEnvironment];


export function instanceOfAdminEbayEnvironment(value: any): boolean {
    for (const key in AdminEbayEnvironment) {
        if (Object.prototype.hasOwnProperty.call(AdminEbayEnvironment, key)) {
            if (AdminEbayEnvironment[key as keyof typeof AdminEbayEnvironment] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminEbayEnvironmentFromJSON(json: any): AdminEbayEnvironment {
    return AdminEbayEnvironmentFromJSONTyped(json, false);
}

export function AdminEbayEnvironmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayEnvironment {
    return json as AdminEbayEnvironment;
}

export function AdminEbayEnvironmentToJSON(value?: AdminEbayEnvironment | null): any {
    return value as any;
}

export function AdminEbayEnvironmentToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminEbayEnvironment {
    return value as AdminEbayEnvironment;
}

